export default {
  name: "pl",
  el: {
    breadcrumb: {
      label: "Breadcrumb", // to be translated
    },
    colorpicker: {
      confirm: "OK",
      clear: "Wyczyść",
    },
    datepicker: {
      now: "Teraz",
      today: "Dzisiaj",
      cancel: "Anuluj",
      clear: "Wyczyść",
      confirm: "OK",
      selectDate: "Wybierz datę",
      selectTime: "Wybierz godzinę",
      startDate: "Data początkowa",
      startTime: "Godzina początkowa",
      endDate: "Data końcowa",
      endTime: "Czas końcowa",
      prevYear: "Poprzedni rok",
      nextYear: "Następny rok",
      prevMonth: "Poprzedni miesiąc",
      nextMonth: "Następny miesiąc",
      year: "rok",
      month1: "styczeń",
      month2: "luty",
      month3: "marzec",
      month4: "kwiecień",
      month5: "maj",
      month6: "czerwiec",
      month7: "lipiec",
      month8: "sierpień",
      month9: "wrzesień",
      month10: "październik",
      month11: "listopad",
      month12: "grudzień",
      week: "tydzień",
      weeks: {
        sun: "ND",
        mon: "PON",
        tue: "WT",
        wed: "ŚR",
        thu: "CZW",
        fri: "PT",
        sat: "SOB",
      },
      months: {
        jan: "STY",
        feb: "LUT",
        mar: "MAR",
        apr: "KWI",
        may: "MAJ",
        jun: "CZE",
        jul: "LIP",
        aug: "SIE",
        sep: "WRZ",
        oct: "PAŹ",
        nov: "LIS",
        dec: "GRU",
      },
    },
    select: {
      loading: "Ładowanie",
      noMatch: "Brak dopasowań",
      noData: "Brak danych",
      placeholder: "Wybierz",
    },
    mention: {
      loading: "Ładowanie",
    },
    cascader: {
      noMatch: "Brak dopasowań",
      loading: "Ładowanie",
      placeholder: "Wybierz",
      noData: "Brak danych",
    },
    pagination: {
      goto: "Idź do",
      pagesize: "/stronę",
      total: "Wszystkich {total}",
      pageClassifier: "",
      page: "Strona", // to be translated
      prev: "Poprzednia strona", // to be translated
      next: "Kolejna strona", // to be translated
      currentPage: "strona {pager}", // to be translated
      prevPages: "Poprzednie {pager} strony", // to be translated
      nextPages: "Kolejne {pager} stron", // to be translated
    },
    messagebox: {
      title: "Wiadomość",
      confirm: "OK",
      cancel: "Anuluj",
      error: "Wiadomość zawiera niedozwolone znaki",
    },
    upload: {
      deleteTip: "kliknij kasuj aby usunąć",
      delete: "Kasuj",
      preview: "Podgląd",
      continue: "Kontynuuj",
    },
    table: {
      emptyText: "Brak danych",
      confirmFilter: "Potwierdź",
      resetFilter: "Resetuj",
      clearFilter: "Wszystko",
      sumText: "Razem",
    },
    tour: {
      next: "Dalej",
      previous: "Wróć",
      finish: "Zakończ",
    },
    tree: {
      emptyText: "Brak danych",
    },
    transfer: {
      noMatch: "Brak dopasowań",
      noData: "Brak danych",
      titles: ["Lista 1", "Lista 2"],
      filterPlaceholder: "Wpisz szukaną frazę",
      noCheckedFormat: "razem: {total}",
      hasCheckedFormat: "wybranych: {checked}/{total}",
    },
    image: {
      error: "BŁĄD",
    },
    pageHeader: {
      title: "Wstecz",
    },
    popconfirm: {
      confirmButtonText: "Tak",
      cancelButtonText: "Nie",
    },
    carousel: {
      leftArrow: "Carousel arrow left", // to be translated
      rightArrow: "Carousel arrow right", // to be translated
      indicator: "Carousel switch to index {index}", // to be translated
    },
  },
};
